import { useState } from 'react'

export default function ProductionPage() {
  const [tasks] = useState([
    { id: 1, video: '成长故事001', status: '待处理', priority: '中', createdAt: '2026-04-17' },
    { id: 2, video: '画作动画002', status: '制作中', createdAt: '2026-04-16' },
  ])

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🎬 视频制作</h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>待处?</div><div style={{ fontSize: 28, color: '#faad14' }}>5</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>制作?</div><div style={{ fontSize: 28, color: '#1890ff' }}>3</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>已完?</div><div style={{ fontSize: 28, color: '#52c41a' }}>128</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>平均时长</div><div style={{ fontSize: 28, color: '#722ed1' }}>2.5?</div></div>
      </div>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>视频名称</th>
              <th style={th}>状?</th>
              <th style={th}>优先?</th>
              <th style={th}>创建时间</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map(t => (
              <tr key={t.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}>{t.video}</td>
                <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: t.status === '待处理' ? '#1890ff' : '#e6f4ff', color: t.status === '待处理' ? '#1890ff' : '#1890ff' }}>{t.status}</span></td>
                <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: t.priority === '高' ? '#1890ff' : '#f5f5f5', color: t.priority === '高' ? '#1890ff' : '#666' }}>{t.priority}</span></td>
                <td style={{ ...td, color: '#999' }}>{t.createdAt}</td>
                <td style={td}><button style={{ ...btn, background: '#1890ff', color: '#666' }}>处理</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
